import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnidadMedidaService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getUnidadMedida(): Observable<any> {
    return this.http.get(this.baseUrl + 'parUnidadMedidas', { headers: this.header(this.token) });
  }

  getUnidadMedidaActivo(): Observable<any> {
    return this.http.get(this.baseUrl + 'parUnidadMedidasActivo', { headers: this.header(this.token) });
  }

  getUnidadMedidaById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parUnidadMedida/' + id, { headers: this.header(this.token) });
  }

  postUnidadMedida(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'parUnidadMedida', bodyString, { headers: this.header(this.token) });
  }

  putUnidadMedida(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parUnidadMedida', bodyString, { headers: this.header(this.token) });
  }

  deleteUnidadMedida(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parUnidadMedida/' + id, { headers: this.header(this.token) });
  }
}
